<template>
  <v-dialog
    v-model="opened"
    content-class="increase-dialog"
    max-width="350"
    persistent
  >
    <h3>{{ title }}</h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form class="mt-3" ref="balance-form" @submit.prevent="onSubmit">
      <v-text-field
        v-model="formData.amount"
        dense
        outlined
        placeholder="0"
        :rules="rules.amount"
      />

      <v-textarea
        v-model="formData.comment"
        height="100"
        dense
        outlined
        no-resize
        :placeholder="
          isDecrease
            ? $t('common.fields.decreaseBalanceReason')
            : $t('common.fields.comment')
        "
        :rules="rules.comment"
      />

      <v-btn
        type="submit"
        color="warning"
        elevation="0"
        block
        :loading="loading"
      >
        {{ $t('common.btns.confirm') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
import CryptoJS from 'crypto-js';

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'increase',
    },
    editData: {
      default: null,
    },
  },
  data() {
    return {
      loading: false,

      formData: {
        amount: '',
        comment: '',
      },

      rules: {
        amount: [
          /* eslint-disable */
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) =>
            (v && v.length < 8) ||
            !v ||
            this.$t('common.fields.validation.field.balance'),
          (v) =>
            /^\d+$/.test(v) ||
            this.$t('common.fields.validation.field.balance'),
          (v) =>
            (v && +v > 0) ||
            !v ||
            this.$t('common.fields.validation.field.balance'),
        ],
        comment: [
          (v) =>
            (v && !!v.trim()) ||
            this.$t('common.fields.validation.field.required'),
        ],
        /* eslint-enable */
      },
    };
  },
  watch: {
    opened(val) {
      if (!val) {
        this.$refs['balance-form'].reset();
        return;
      }

      if (this.editData) {
        this.formData.amount = String(this.editData.amount);
        this.formData.comment = this.editData.comment;
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    isDecrease() {
      return this.type === 'decrease';
    },
    userId() {
      return this.$store.getters['user/getUserId'];
    },
    title() {
      return this.isDecrease
        ? this.$t('common.btns.decreaseBalance')
        : this.$t('common.btns.increaseBalance');
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    async onSubmit() {
      const isValid = this.$refs['balance-form'].validate();

      if (!isValid) return;

      this.loading = true;

      const signature = CryptoJS.MD5(
        `${this.userId}${this.formData.amount}${process.env.VUE_APP_SECRET}`,
      ).toString();

      const credentials = {
        signature,
        amount: this.formData.amount,
        comment: this.formData.comment,
      };

      if (!this.editData) credentials.userId = this.userId;

      let response;

      if (this.editData) {
        response = await this.$store.dispatch('user/updateTransaction', {
          id: this.editData.id,
          credentials,
        });
      } else {
        response = await this.$store.dispatch('user/changeBalance', {
          type: this.type,
          credentials,
        });
      }

      if (response.message) {
        await this.$store.dispatch('driver/fetchDriverTransactionsData', {
          page: 1,
          driverId: this.$route.params.driverId,
        });

        this.opened = false;

        this.$emit('updated', {
          success: true,
          message: response.message,
        });
      } else {
        this.$emit('updated', {
          error: true,
          message: this.$t('common.errors.APIerror'),
        });
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.increase-dialog {
  padding: 10px;
  background-color: #fff;
}
</style>
